import type { TopUpStatus } from '@mypoz/shared';
import { STATUS_TONES } from '@mypoz/shared';
import { useTranslation } from '@mypoz/i18n';
import { StatusChip } from '@mypoz/ui';

export interface TopUpStatusChipProps {
  status: TopUpStatus;
}

/**
 * A top-up's status, in the same dot-and-label chip as orders, packages and coupons. The colour
 * comes from `STATUS_TONES.topUp`:
 *
 * - `success` (green) — `END`, the top-up went through;
 * - `incomplete` (muted) — `INVALID`, started and never paid. The most common state by far (492 of
 *   553 on the test account, MYP-107), and not an error, so it is not coloured;
 * - `failed` (red) — a status that says it failed;
 * - `cancelled` (muted) — `CANCEL`, the customer cancelled (MYP-134): their choice, not an error;
 * - `pending` (muted) — any status the vendor adds that the app does not know yet.
 */
export function TopUpStatusChip({ status }: TopUpStatusChipProps) {
  const { t } = useTranslation();

  return (
    <StatusChip tone={STATUS_TONES.topUp[status]}>
      {t(`wallet.history.status.${status}`)}
    </StatusChip>
  );
}
